import { createStyles } from 'antd-style'

const useStyles = createStyles(({ token }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: token.paddingXS,
    paddingBlockEnd: token.paddingSM,
    color: token.colorTextTertiary,
    textAlign: 'center'
  }
}))

export const RightInformation = () => {
  const { styles } = useStyles()

  return (
    <div className={styles.container}>
      <span>© 2013 Eastcoal.cn, All Rights Reserved</span>
      <span>
        东方煤炭电子交易中心 版权所有 增值电信业务经营许可证沪B2-2009069
        沪ICP备15006920号
      </span>
    </div>
  )
}
